<template>
  <v-container fluid fill-height class="background fill-height">
    <v-card class="white mx-auto" width="30vw" height="50vh" min-height="480px">
      
      <div class="white mb-3">
        <v-img max-width="20vw" class="mx-auto" src="../assets/DigiWheel_Logo_Evolution_Company_RGB_Yellow_Black.svg"/>
      </div>


      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        class="text-center"
      >
        <v-text-field
          v-model="email"
          :placeholder="$t('resetPassword.emailLabel')"
          :rules="emailRules"
          class="mb-n2 rounded-lg mx-auto"
          style="width: 70%"
          outlined
          density="compact"
          single-line
          type="email"
        ></v-text-field>

        <v-btn
          style="width: 70%"
          color="black white--text"
          class="rounded-lg mb-3"
          :disabled="!valid || loading"
          :loading="loading"
          @click="sendCode"
        >
          {{ $t('resetPassword.sendButton') }}
        </v-btn>

        <div>
          <v-btn
            text
            color="primary"
            @click="$router.push('/login')"
          >
            {{ $t('resetPassword.backToLogin') }}
          </v-btn>
        </div>
      </v-form>

      <v-alert
        v-if="successMessage"
        type="success"
        class="mx-8 mt-4"
        dense
      >
        {{ successMessage }}
      </v-alert>

      <v-alert
        v-if="errorMessage"
        type="error"
        class="mx-8 mt-4"
        dense
      >
        {{ errorMessage }}
      </v-alert>

    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: "ResetPassword",
  data: () => ({
    valid: false,
    email: '',
    loading: false,
    successMessage: '',
    errorMessage: '',
    emailRules: [
      v => !!v || 'Email is required',
      v => /.+@.+\..+/.test(v) || 'Email must be valid'
    ]
  }),
  methods: {
    ...mapActions(['requestPasswordReset']),
    async sendCode() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      this.errorMessage = '';
      this.successMessage = '';

      try {
        const result = await this.requestPasswordReset(this.email);
        if (result.success) {
          this.successMessage = this.$t('resetPassword.codeSent');
          setTimeout(() => {
            this.$router.push('/verifycode');
          }, 2000);
        } else {
          this.errorMessage = result.error || this.$t('resetPassword.errors.invalidEmail');
        }
      } catch (error) {
        this.errorMessage = 'An error occurred. Please try again.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.background {
  background-color: #f5f5f5;
}
</style>